/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Row,
  Col,
  Input,
  Checkbox,
  Image,
  Divider,
  Space,
  Typography,
  Spin,
} from 'antd';
import CartApi from 'apis/CartApi';
import { defaultImage } from 'assets/images';
import { BoxCube, Copy, Dollar, Star, NavigationRight } from 'assets/svg';
import { lowerFirst } from 'lodash';
import { check } from 'prettier';
import { useEffect, useMemo, useState } from 'react';
import { useMutation } from 'react-query';
import formatCurrencyVND from 'utils/formatCurrencyVND';

interface IProps {
  isList?: boolean;
  item: any;
  checked: boolean;
  index: number;
  packQuantity: number;
  changeDetected: any;
  checkPack: (maBo: string, packQuantity: number) => boolean;
  handleCheckProduct: (index: number, product: any, event: any) => void;
  handleMinMaxProduct: (index: number, product: any) => void;
  handleGetPair: (maCap: string) => void;
  removeProductInPack: (mabo: string) => void;
  showModal: (data: any) => void;
  checkCartRegisterDetailId: (cart_register_detail_id: number) => {
    IsIdExist: boolean;
    product: any;
  };
}

export default function ProductCartTVV(props: IProps): JSX.Element {
  const {
    isList,
    item,
    checked,
    index,
    packQuantity,
    changeDetected,
    handleCheckProduct,
    handleMinMaxProduct,
    showModal,
    handleGetPair,
    checkPack,
    removeProductInPack,
    checkCartRegisterDetailId,
  } = props;

  const [product, setProduct] = useState<any>(props.item);
  const [borderColor, setBorderColor] = useState<any>();
  const [getPairLoading, setGetPairLoading] = useState<boolean>(false);
  const [anotherProduct, setAnotherProduct] = useState<any>();
  const [pairCode, setPairCode] = useState<string>();

  const [productListPack, SetProductListPack] = useState<any[]>();
  const [IsPackEnough, setIsPackEnough] = useState<boolean>();
  const [packQuantityMain, setPackQuantityMain] = useState<number>(0);

  const { Text } = Typography;

  const isOrderMaxEmpty =
    product.order_max === undefined || product.order_max === null
      ? true
      : false;

  const isOrderMinEmpty =
    product.order_min === undefined || product.order_min === null
      ? true
      : false;

  const IsAgingRequire = () => {
    if (
      product?.aging_shop == 0 ||
      product?.aging_shop == null ||
      product.aging_shop == undefined
    ) {
      return false;
    } else {
      if (product.aging_shop > 3) {
        return false;
      } else {
        if (
          product?.old_order_min !== null &&
          product?.old_order_max !== null
        ) {
          return true;
        } else {
          return false;
        }
      }
    }
  };

  const IsValidateAgingMin = () => {
    if (IsAgingRequire() == false) {
      return true;
    } else {
      if (product.old_order_min > product.order_min) {
        return false;
      } else {
        return true;
      }
    }
  };

  const IsValidateAgingMax = () => {
    if (IsAgingRequire() == false) {
      return true;
    } else {
      if (product.old_order_max > product.order_max) {
        return false;
      } else {
        return true;
      }
    }
  };

  function ChangeValueMin(event: any) {
    const newProduct = {
      ...product,
      order_min: !event.target.value ? undefined : Number(event.target.value),
    };
    handleMinMaxProduct(index, newProduct);
    setProduct(newProduct);
  }

  function ChangeValueMax(event: any) {
    const newProduct = {
      ...product,
      order_max: !event.target.value ? undefined : Number(event.target.value),
    };
    handleMinMaxProduct(index, newProduct);
    setProduct(newProduct);
  }

  useEffect(() => {
    if (product.zma_ts_cap != '') {
      setGetPairLoading(true);
      CartApi.getPair(product.cart_register_detail_id)
        .then((res) => {
          setPairCode(res.data?.zma_ts_cap);
          setAnotherProduct(res.data);
          setGetPairLoading(false);
        })
        .catch((err) => {
          console.log('API lỗi');
          setGetPairLoading(false);
        });
    }
  }, []);

  const { mutate: getZmaBo, isLoading: getZmaBoLoading } = useMutation(
    ['getZmaBo'],
    () => CartApi.getPack(product.cart_register_detail_id),
    {
      onSuccess: (response: any) => {
        SetProductListPack(response.data);
        setPackQuantityMain((response.data || []).length + 1);
      },
      onError: (error: any) => {
        console.log(error);
      },
    }
  );

  const autoFillProductInPack = (productListPack: any[]) => {
    if (product.bat_buoc === true) {
      productListPack.map((productInPack: any) => {
        if (
          checkCartRegisterDetailId(productInPack.cart_register_detail_id)
            ?.IsIdExist === false
        ) {
          const newPackProduct = {
            ...productInPack,
            order_min: product.order_min,
            order_max: product.order_max,
          };
          handleMinMaxProduct(index, newPackProduct);
        } else {
          if (
            checkCartRegisterDetailId(productInPack.cart_register_detail_id)
              ?.product?.order_max !== product.order_max ||
            checkCartRegisterDetailId(productInPack.cart_register_detail_id)
              ?.product?.order_min !== product.order_min
          ) {
            const newPackProduct = {
              ...productInPack,
              order_min: product.order_min,
              order_max: product.order_max,
            };
            handleMinMaxProduct(index, newPackProduct);
          }
        }
      });
    }
  };

  useEffect(() => {
    if (pairCode !== undefined) {
      if (checked == true) {
        const newPairProduct = {
          ...anotherProduct,
          order_min: product.order_min,
          order_max: product.order_max,
        };
        handleMinMaxProduct(index, newPairProduct);
      } else {
        if (
          product.order_max !== undefined &&
          product.order_min !== undefined
        ) {
          handleGetPair(pairCode);
          delete product.order_min;
          delete product.order_max;
          setProduct(product);
        } else {
          handleGetPair(pairCode);
        }
      }
    }

    if (product.zma_bo !== '' && checked === true) {
      getZmaBo();
    }
  }, [checked, product.order_max, product.order_min]);

  useMemo(() => {
    if (product.zma_bo !== '') {
      setIsPackEnough(checkPack(product.zma_bo, packQuantityMain));
    }
  }, [
    checked,
    product.order_max,
    product.order_min,
    packQuantity,
    packQuantityMain,
  ]);

  const renderProductInPack = (maBo: string) => {
    if (IsPackEnough === false) {
      return (
        <>
          <div>Mã bộ: {maBo}</div>
          <div>Các sản phẩm trong bộ:</div>
          {productListPack?.map((item: any, index: any) => (
            <div key={index}>- Mã mẫu: {item?.ma_mau}</div>
          ))}
        </>
      );
    }
  };

  const validateUnisex = (product: any) => {
    if (
      product?.gioitinh === '3' &&
      product?.chung_loai_code === '7108' &&
      product?.nganh_hang === 'Vàng' &&
      product?.zma_ts_cap !== ''
    ) {
      if (
        (product?.order_max ?? 0) % 2 == 0 &&
        (product?.order_min ?? 0) % 2 == 0
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };

  const renderValidateCSS = () => {
    const arrCss = [];
    if (product.order_min == undefined || product.order_max == undefined) {
      if (checked === true) {
        arrCss.push('border-2 !border-[#DC362E]');
      } else {
        arrCss.push('');
      }
      arrCss.push('');
    }

    if (product.order_max <= 0 || product.order_min <= 0) {
      arrCss.push('border-2 !border-[#DC362E]');
    } else {
      arrCss.push('');
    }

    if (product.order_max < product.order_min) {
      arrCss.push('border-2 !border-[#DC362E]');
    } else {
      arrCss.push('');
    }

    if (product.order_max >= 5 || product.order_min >= 5) {
      arrCss.push('border-2 border-[#ffee00]');
    } else {
      arrCss.push('');
    }

    if (product.order_max - product.order_min >= 4) {
      arrCss.push('border-2 border-[#ffee00]');
    } else {
      arrCss.push('');
    }

    if (validateUnisex(product) === false) {
      arrCss.push('border-2 !border-[#DC362E]');
    } else {
      arrCss.push('');
    }

    if (IsValidateAgingMin() === false) {
      arrCss.push('border-2 !border-[#DC362E]');
    } else {
      arrCss.push('');
    }

    if (IsValidateAgingMax() === false) {
      arrCss.push('border-2 !border-[#DC362E]');
    } else {
      arrCss.push('');
    }

    if (checked == false) {
      if (IsAgingRequire() == true) {
        arrCss.push('border-2 !border-[#DC362E]');
      } else {
        arrCss.push('');
      }
    } else {
      arrCss.push('');
    }

    if (product.bat_buoc === false) {
      if (IsPackEnough == false) {
        if (productListPack === undefined) {
          arrCss.push('');
        } else {
          arrCss.push('border-2 border-[#ffee00]');
        }
      } else {
        arrCss.push('');
      }
    }

    const newBorderColor = arrCss.join(' ');
    return newBorderColor;
  };

  useEffect(() => {
    const arrCss = [];
    if (product.order_min == undefined || product.order_max == undefined) {
      if (checked === true) {
        arrCss.push('border-2 !border-[#DC362E]');
      } else {
        arrCss.push('');
      }
      arrCss.push('');
    }

    if (product.order_max <= 0 || product.order_min <= 0) {
      arrCss.push('border-2 !border-[#DC362E]');
    } else {
      arrCss.push('');
    }

    if (product.order_max < product.order_min) {
      arrCss.push('border-2 !border-[#DC362E]');
    } else {
      arrCss.push('');
    }

    if (product.order_max >= 5 || product.order_min >= 5) {
      arrCss.push('border-2 border-[#ffee00]');
    } else {
      arrCss.push('');
    }

    if (product.order_max - product.order_min >= 4) {
      arrCss.push('border-2 border-[#ffee00]');
    } else {
      arrCss.push('');
    }

    if (validateUnisex(product) === false) {
      arrCss.push('border-2 !border-[#DC362E]');
    } else {
      arrCss.push('');
    }

    if (IsValidateAgingMin() === false) {
      arrCss.push('border-2 !border-[#DC362E]');
    } else {
      arrCss.push('');
    }

    if (IsValidateAgingMax() === false) {
      arrCss.push('border-2 !border-[#DC362E]');
    } else {
      arrCss.push('');
    }

    if (checked == false) {
      if (IsAgingRequire() == true) {
        arrCss.push('border-2 !border-[#DC362E]');
      } else {
        arrCss.push('');
      }
    } else {
      arrCss.push('');
    }

    const newBorderColor = arrCss.join(' ');
    setBorderColor(newBorderColor);
  }, [product.order_min, product.order_max, checked, changeDetected]);

  useEffect(() => {
    if (isOrderMinEmpty === true || isOrderMaxEmpty === true) {
      setBorderColor('!border-2 !border-[#DC362E]');
    }

    if (isOrderMinEmpty === true && isOrderMaxEmpty === true) {
      if (checked === true) {
        setBorderColor('!border-2 !border-[#DC362E]');
      } else {
        setBorderColor('');
      }
    }
  }, [isOrderMaxEmpty, isOrderMinEmpty, checked, product, changeDetected]);

  useEffect(() => {
    // if (product.zma_bo !== '' && IsPackEnough === false) {
    //   getZmaBo();
    // }
    if (product.bat_buoc === false) {
      if (IsPackEnough == false) {
        if (productListPack === undefined) {
          setBorderColor('');
        } else {
          setBorderColor('border-2 border-[#ffee00]');
        }
      } else {
        setBorderColor('');
      }
    }
  }, [packQuantity, packQuantityMain, checked, changeDetected, IsPackEnough]);
  //edited 27/6/2024:changeDetected

  useEffect(() => {
    if (product.bat_buoc === true && checked == true) {
      autoFillProductInPack(productListPack || []);
    }

    if (product.bat_buoc === true && checked == false) {
      removeProductInPack(product.zma_bo);
      delete product['order_min'];
      delete product['order_max'];
      setProduct(product);
    }
  }, [checked, productListPack]);

  useEffect(() => {
    setProduct(props.item);
  }, [props.item.order_min, props.item.order_max]);

  return (
    <>
      {isList == true ? (
        <Spin spinning={getPairLoading || getZmaBoLoading}>
          <Row>
            <Col
              className={`bg-white ${
                checked == true
                  ? isOrderMaxEmpty == true || isOrderMinEmpty == true
                    ? '!border-2 !border-[#DC362E]'
                    : IsValidateAgingMax() == false ||
                      IsValidateAgingMin() == false
                    ? '!border-2 !border-[#DC362E]'
                    : ''
                  : IsAgingRequire() == true
                  ? 'border-2 !border-[#DC362E]'
                  : ''
              } ${renderValidateCSS()}  ${borderColor}`}
              // onClick={() =>
              //   showModal({
              //     product: product,
              //     ChangeValueMin,
              //     ChangeValueMax,
              //   })
              // }
            >
              <Row>
                <Col
                  onClick={(event) => {
                    event.stopPropagation();
                  }}
                  style={{
                    position: 'sticky',
                    left: '0px',
                    zIndex: '1',
                    background: 'white',
                    boxShadow: '3px 0px 3px 0px rgba(0, 0, 0, 0.05)',
                    // padding: '12px',
                    width: '420px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <Col
                    style={{
                      display: 'flex',
                      justifyContent: 'space-around',
                      alignItems: 'center',
                      width: '100%',
                    }}
                  >
                    <Checkbox
                      checked={checked}
                      onClick={(event) => {
                        event.stopPropagation();
                        handleCheckProduct(index, product, event);
                      }}
                    />
                    <Image
                      width="40px"
                      height="40px"
                      src={product.image_default || defaultImage}
                      className="rounded-lg"
                      style={{ objectFit: 'contain' }}
                      preview={false}
                      onClick={() =>
                        showModal({
                          product: product,
                          ChangeValueMin,
                          ChangeValueMax,
                        })
                      }
                    />
                    <Col
                      style={{
                        width: '150px',
                        padding: '4px',
                        alignContent: 'center',
                      }}
                    >
                      {product.ma_mau}
                    </Col>
                    <Col
                      style={{
                        width: '150px',
                        padding: '4px',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        alignContent: 'center',
                      }}
                    >
                      {product?.ten_mau || '-'}
                    </Col>
                  </Col>
                </Col>
                {/* <Col
                  style={{
                    width: '90px',
                    padding: '4px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Image
                    width="40px"
                    height="40px"
                    src={product.image_default || defaultImage}
                    className="rounded-lg"
                    style={{ objectFit: 'contain' }}
                    preview={false}
                    onClick={() =>
                      showModal({
                        product: product,
                        ChangeValueMin,
                        ChangeValueMax,
                      })
                    }
                  />
                </Col> */}
                {/* <Col
                  style={{
                    width: '150px',
                    padding: '4px',
                    alignContent: 'center',
                  }}
                >
                  {product.ma_mau}
                </Col>
                <Col
                  style={{
                    width: '150px',
                    padding: '4px',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    alignContent: 'center',
                  }}
                >
                  {product?.ten_mau || '-'}
                </Col> */}
                <Col
                  style={{
                    width: '150px',
                    padding: '4px',
                    textAlign: 'right',
                    alignContent: 'center',
                  }}
                >
                  {formatCurrencyVND(product.cost_price)}
                </Col>
                <Col
                  style={{
                    width: '120px',
                    padding: '4px',
                    textAlign: 'center',
                    alignContent: 'center',
                  }}
                >
                  {product.bat_buoc === true ? 'Bắt buộc' : ''}
                </Col>
                <Col
                  style={{
                    width: '120px',
                    padding: '4px',
                    textAlign: 'center',
                    alignContent: 'center',
                  }}
                >
                  {IsAgingRequire() === true ? 'Bắt buộc' : ''}
                </Col>
                <Col
                  style={{
                    width: '100px',
                    padding: '4px',
                    alignContent: 'center',
                  }}
                >
                  {product?.color || '-'}
                </Col>

                <Col
                  style={{
                    width: '150px',
                    padding: '4px',
                    alignContent: 'center',
                  }}
                >
                  {product.doanh_so_6_thang_mon ?? '-'}
                </Col>
                <Col
                  style={{
                    width: '150px',
                    padding: '4px',
                    alignContent: 'center',
                  }}
                >
                  {product.ton_kho_hien_tai_mon ?? '-'}
                </Col>
                <Col
                  style={{
                    width: '170px',
                    padding: '4px',
                    textAlign: 'right',
                    alignContent: 'center',
                  }}
                >
                  {formatCurrencyVND(product.cost_price) ?? '-'}
                </Col>
                <Col
                  style={{
                    width: '170px',
                    padding: '4px',
                    textAlign: 'right',
                    alignContent: 'center',
                  }}
                >
                  {formatCurrencyVND(product.price) ?? '-'}
                </Col>
                <Col
                  style={{
                    width: '170px',
                    padding: '4px',
                    alignContent: 'center',
                  }}
                >
                  {product.line_xman_text ?? '-'}
                </Col>
                <Col
                  style={{
                    width: '170px',
                    padding: '4px',
                    alignContent: 'center',
                  }}
                >
                  {product.nganh_hang ?? '-'}
                </Col>
                <Col
                  style={{
                    width: '170px',
                    padding: '4px',
                    alignContent: 'center',
                  }}
                >
                  {product.line_sap_text ?? '-'}
                </Col>
                <Col
                  style={{
                    width: '170px',
                    padding: '4px',
                    alignContent: 'center',
                  }}
                >
                  {product.chung_loai_text ?? '-'}
                </Col>
                <Col
                  style={{
                    width: '170px',
                    padding: '4px',
                    alignContent: 'center',
                  }}
                >
                  {product.zma_ts_cap_text ?? '-'}
                </Col>
                <Col
                  style={{
                    width: '170px',
                    padding: '4px',
                    alignContent: 'center',
                  }}
                >
                  {product.zma_bo_text ?? '-'}
                </Col>
                <Col
                  style={{
                    width: '170px',
                    padding: '4px',
                    alignContent: 'center',
                  }}
                >
                  {product.bst_text ?? '-'}
                </Col>
                <Col
                  style={{
                    width: '170px',
                    padding: '4px',
                    alignContent: 'center',
                  }}
                >
                  {product.nhom_dac_biet ?? '-'}
                </Col>
                <Col
                  style={{
                    width: '170px',
                    padding: '4px',
                    alignContent: 'center',
                  }}
                >
                  {(product.gioitinh ?? '-') == '2'
                    ? 'Nam'
                    : (product.gioitinh ?? '-') == '4'
                    ? 'Nữ'
                    : (product.gioitinh ?? '-') == '3'
                    ? 'Nam / Nữ'
                    : (product.gioitinh ?? '-') == '5'
                    ? 'Trẻ em'
                    : '-'}
                </Col>
                <Col
                  style={{
                    width: '170px',
                    padding: '4px',
                    alignContent: 'center',
                  }}
                >
                  {product.material_type ?? '-'}
                </Col>

                <Col
                  style={{
                    width: '170px',
                    padding: '4px',
                    alignContent: 'center',
                  }}
                >
                  {product.purity_of_gold ?? '-'}
                </Col>
                <Col
                  style={{
                    width: '170px',
                    padding: '4px',
                    alignContent: 'center',
                  }}
                >
                  {product.loai_da ?? '-'}
                </Col>
                <Col
                  style={{
                    width: '170px',
                    padding: '4px',
                    alignContent: 'center',
                  }}
                >
                  {product.nhom_da ?? '-'}
                </Col>
                <Col
                  style={{
                    width: '170px',
                    padding: '4px',
                    alignContent: 'center',
                  }}
                >
                  {product.ohot_kc_text ?? '-'}
                </Col>
                <Col
                  style={{
                    width: '170px',
                    padding: '4px',
                    alignContent: 'center',
                  }}
                >
                  {product.kldg_3tc ?? '-'}
                </Col>
                <Col
                  style={{
                    width: '170px',
                    padding: '4px',
                    alignContent: 'center',
                  }}
                >
                  {product.dghh_kv ?? '-'}
                </Col>
                <Col
                  style={{
                    width: '200px',
                    padding: '4px',
                    alignContent: 'center',
                  }}
                >
                  {product.tongsl_ton ?? '-'}
                </Col>
                <Col
                  style={{
                    width: '250px',
                    padding: '4px',
                    alignContent: 'center',
                  }}
                >
                  {product.doanhthu_tb_1th ?? '-'}
                </Col>
                <Col
                  style={{
                    width: '170px',
                    padding: '4px',
                    alignContent: 'center',
                  }}
                >
                  {product.aging_danh_muc ?? '-'}
                </Col>
                <Col
                  style={{
                    width: '170px',
                    padding: '4px',
                    alignContent: 'center',
                  }}
                >
                  {product.aging_shop ?? '-'}
                </Col>
                <Col
                  style={{
                    position: 'sticky',
                    right: '0px',
                    zIndex: '1',
                    background: 'white',
                    width: '184px',
                    // paddingTop: '4px',
                    paddingRight: '8px',
                    paddingLeft: '8px',
                    textAlign: 'center',
                    boxShadow: '-3px 0px 3px -0px rgba(0, 0, 0, 0.05)',
                  }}
                >
                  <Row gutter={5} justify="space-between" align="middle">
                    <Col style={{ flex: 1 }}>
                      <Row align="middle" justify="center">
                        <div style={{ fontSize: '8px' }}>{'Min: '}</div>
                        <strong style={{ fontSize: '10px' }}>
                          {product.old_order_min}
                        </strong>
                      </Row>
                      <Input
                        min={0}
                        style={{
                          height: '22px',
                          width: '100%',
                          borderRadius: '5px',
                          textAlign: 'center',
                          padding: '0px',
                        }}
                        type="number"
                        onClick={(event) => event.stopPropagation()}
                        onChange={(event) => ChangeValueMin(event)}
                        defaultValue={product.order_min}
                        value={product.order_min}
                      />
                    </Col>
                    <Copy
                      onClick={(event) => {
                        event.stopPropagation();
                        if (product.old_order_min && product.old_order_max) {
                          const updatedProduct = { ...product };
                          updatedProduct.order_min = product.old_order_min;
                          updatedProduct.order_max = product.old_order_max;
                          handleMinMaxProduct(index, updatedProduct);
                          setProduct(updatedProduct);
                        }
                      }}
                    />
                    <Col style={{ flex: 1 }}>
                      <Row align="middle" justify="center">
                        <div style={{ fontSize: '8px' }}>{'Max: '}</div>
                        <strong style={{ fontSize: '10px' }}>
                          {product.old_order_max}
                        </strong>
                      </Row>
                      <Input
                        min={0}
                        style={{
                          height: '22px',
                          width: '100%',
                          borderRadius: '5px',
                          textAlign: 'center',
                          padding: '0px',
                        }}
                        type="number"
                        onClick={(event) => event.stopPropagation()}
                        onChange={(event) => ChangeValueMax(event)}
                        defaultValue={product.order_max}
                        value={product.order_max}
                      />
                    </Col>
                  </Row>
                  <Col
                    className="text-secondary"
                    style={{
                      fontSize: '10px',
                      // marginTop: '5px',
                      textAlign: 'center',
                      padding: '0px',
                    }}
                  >
                    {product.order_min
                      ? formatCurrencyVND(
                          product.cost_price * product.order_min
                        )
                      : '0đ'}
                    {' - '}
                    {product.order_max
                      ? formatCurrencyVND(
                          product.cost_price * product.order_max
                        )
                      : '0đ'}
                  </Col>
                  <Col>
                    <Row>
                      <p style={{ fontSize: '10px', color: '#DC362E' }}>
                        {isOrderMinEmpty === true && isOrderMaxEmpty === false
                          ? 'Số lượng min không được bỏ trống'
                          : ''}
                      </p>
                    </Row>
                    <Row>
                      <p style={{ fontSize: '10px', color: '#DC362E' }}>
                        {isOrderMinEmpty === false && isOrderMaxEmpty === true
                          ? 'Số lượng max không được bỏ trống'
                          : ''}
                      </p>
                    </Row>
                    <Row>
                      <p style={{ fontSize: '10px', color: '#DC362E' }}>
                        {isOrderMinEmpty === true &&
                        isOrderMaxEmpty === true &&
                        checked === true
                          ? 'Số lượng min,max không được bỏ trống'
                          : ''}
                      </p>
                    </Row>

                    <Row>
                      <p style={{ fontSize: '10px', color: '#DC362E' }}>
                        {product.order_min <= 0
                          ? 'Số lượng min không được nhỏ hơn hoặc bằng 0'
                          : ''}
                      </p>
                    </Row>
                    <Row>
                      <p style={{ fontSize: '10px', color: '#DC362E' }}>
                        {product.order_min > product.order_max
                          ? 'Số lượng min không được lớn hơn số lượng max'
                          : ''}
                      </p>
                    </Row>
                    <Row>
                      <p style={{ fontSize: '10px', color: '#DC362E' }}>
                        {product.order_min >= 5
                          ? 'Số lượng đăng kí MIN quá lớn (trên 4 món)'
                          : ''}
                      </p>
                    </Row>
                    <Row>
                      <p style={{ fontSize: '10px', color: '#DC362E' }}>
                        {product.order_max >= 5
                          ? 'Số lượng đăng kí MAX quá lớn (trên 4 món)'
                          : ''}
                      </p>
                    </Row>
                    <Row>
                      <p style={{ fontSize: '10px', color: '#DC362E' }}>
                        {product.order_max - product.order_min >= 4
                          ? 'Số lượng chênh lệch giữa MIN-MAX quá lớn (trên 3 món)'
                          : ''}
                      </p>
                    </Row>
                    <Row>
                      <p style={{ fontSize: '10px', color: '#DC362E' }}>
                        {product.order_min == undefined ||
                        product.order_max == undefined ||
                        product.order_min == null ||
                        product.order_max == null
                          ? ''
                          : validateUnisex(product) === true
                          ? ''
                          : 'Mẫu thuộc nhẫn Unisex, phải đăng ký số lượng MIN-MAX chẵn'}
                      </p>
                    </Row>
                    <Row>
                      {' '}
                      <p style={{ fontSize: '10px', color: '#DC362E' }}>
                        {product.zma_bo !== '' && IsPackEnough == false
                          ? renderProductInPack(product.zma_bo)
                          : ''}
                      </p>
                    </Row>
                    <Row>
                      <p style={{ fontSize: '10px', color: '#DC362E' }}>
                        {IsValidateAgingMin() == false
                          ? 'aging nhỏ hơn hoặc bằng 3, min đăng ký mới không được nhỏ hơn min đăng ký cũ'
                          : ''}
                      </p>
                    </Row>
                    <Row>
                      <p style={{ fontSize: '10px', color: '#DC362E' }}>
                        {IsValidateAgingMax() == false
                          ? 'aging nhỏ hơn hoặc bằng 3, max đăng ký mới không được nhỏ hơn max đăng ký cũ'
                          : ''}
                      </p>
                    </Row>
                    <Row>
                      <p style={{ fontSize: '10px', color: '#DC362E' }}>
                        {IsAgingRequire() == false
                          ? ''
                          : checked == true
                          ? ''
                          : 'Sản phẩm có Aging = 1,2,3 bắt buộc phải được đăng ký'}
                      </p>
                    </Row>
                  </Col>

                  <Col>
                    <Row>
                      <p style={{ fontSize: '10px', color: '#DC362E' }}>
                        {product.isOrderMinEmpty && !product.isOrderMaxEmpty
                          ? 'Số lượng min không được bỏ trống'
                          : ''}
                      </p>
                    </Row>
                    <Row>
                      <p style={{ fontSize: '10px', color: '#DC362E' }}>
                        {!product.isOrderMinEmpty && product.isOrderMaxEmpty
                          ? 'Số lượng max không được bỏ trống'
                          : ''}
                      </p>
                    </Row>
                    <Row>
                      <p style={{ fontSize: '10px', color: '#DC362E' }}>
                        {product.isOrderMinEmpty && product.isOrderMaxEmpty
                          ? 'Số lượng min max không được bỏ trống'
                          : ''}
                      </p>
                    </Row>
                  </Col>
                  <Col>
                    <Row>
                      <p style={{ fontSize: '10px', color: '#DC362E' }}>
                        {!product.isOrderMinEmpty &&
                        !product.isOrderMaxEmpty &&
                        IsValidateAgingMin() === false &&
                        product.bat_buoc === true
                          ? `Min phải nằm trong khoảng ${product.order_aging_min_range.min} - ${product.order_aging_min_range.max}`
                          : ''}
                      </p>
                    </Row>
                    <Row>
                      <p style={{ fontSize: '10px', color: '#DC362E' }}>
                        {!product.isOrderMinEmpty &&
                        !product.isOrderMaxEmpty &&
                        IsValidateAgingMax() === false &&
                        product.bat_buoc === true
                          ? `Max phải nằm trong khoảng ${product.order_aging_max_range.min} - ${product.order_aging_max_range.max}`
                          : ''}
                      </p>
                    </Row>
                  </Col>
                </Col>
              </Row>
            </Col>
          </Row>
        </Spin>
      ) : (
        <Spin spinning={getPairLoading || getZmaBoLoading}>
          <Col
            // className={`rounded-xl bg-white ${borderColor}`}
            className={`rounded-xl bg-white ${
              checked == true
                ? isOrderMaxEmpty == true || isOrderMinEmpty == true
                  ? '!border-2 !border-[#DC362E]'
                  : IsValidateAgingMax() == false ||
                    IsValidateAgingMin() == false
                  ? '!border-2 !border-[#DC362E]'
                  : ''
                : IsAgingRequire() == true
                ? 'border-2 !border-[#DC362E]'
                : ''
            } ${renderValidateCSS()}  ${borderColor}`}
            style={{
              width: '200px',
              padding: '12px',
              marginLeft: '16px',
              marginBottom: '16px',
            }}
          >
            <Col>
              <Row justify="space-between" align="middle">
                <Col style={{ display: 'flex', alignItems: 'center' }}>
                  <Star />
                  <Col style={{ marginLeft: '4px', fontSize: '12px' }}>
                    <strong>{item.kldg_3tc || 'Chưa đánh giá'}</strong>
                  </Col>
                </Col>
                <Col>
                  <Checkbox
                    checked={checked}
                    onClick={(event) =>
                      handleCheckProduct(index, product, event)
                    }
                  ></Checkbox>
                </Col>
              </Row>
            </Col>
            <Col
              style={{
                textAlign: 'center',
                marginTop: '6px',
                marginBottom: '0px',
              }}
            >
              <Image
                width="80px"
                height="80px"
                src={item.image_default || defaultImage}
                className="rounded-lg"
                style={{ objectFit: 'contain' }}
              />
            </Col>

            <Col style={{ fontSize: '12px' }}>Mẫu: {item.ma_mau}</Col>
            <Col
              onClick={() =>
                showModal({ product, ChangeValueMin, ChangeValueMax })
              }
            >
              <strong>
                <Text
                  className="hover:text-[#33AAFF]"
                  style={{ fontSize: '10px', cursor: 'pointer' }}
                  ellipsis={
                    true && {
                      tooltip: (
                        <div style={{ fontSize: '10px' }}>
                          {item?.ten_mau || '-'}
                        </div>
                      ),
                    }
                  }
                >
                  {item?.ten_mau || '-'}
                </Text>
              </strong>
            </Col>
            <Col style={{ paddingTop: '3px' }}>
              <Row justify="space-between" align="middle">
                <Col
                  span={24}
                  className="text-secondary"
                  style={{ fontSize: '10px' }}
                >
                  <strong>Giá vốn: {formatCurrencyVND(item.cost_price)}</strong>
                </Col>
                <Col span={24}>
                  <strong style={{ fontSize: '10px', color: '#DC362E' }}>
                    {product.bat_buoc === true ? 'Bộ bắt buộc' : ''}
                  </strong>
                </Col>
                <Col span={24}>
                  <strong style={{ fontSize: '10px', color: '#DC362E' }}>
                    {IsAgingRequire() == true ? 'Bắt buộc (aging)' : ''}
                  </strong>
                </Col>
              </Row>

              <Row justify="space-between" align="middle">
                <Col span={24} className="flex items-center">
                  <Text
                    style={{ fontSize: '10px' }}
                    ellipsis={
                      true && {
                        tooltip: (
                          <div style={{ fontSize: '10px' }}>
                            {item?.color || '-'}
                          </div>
                        ),
                      }
                    }
                  >
                    Màu sắc TS: {item?.color || '-'}
                  </Text>
                </Col>
              </Row>
            </Col>
            <Col>
              <Divider
                style={{
                  borderTop: '1px dashed rgba(0, 0, 0, 0.2)',
                  marginTop: '8px',
                  marginBottom: '0px',
                }}
                dashed
              />
            </Col>
            <Row align={'top'} style={{ alignItems: 'flex-start' }}>
              <Dollar />
              <Col style={{ paddingTop: '8px' }}>
                <Col style={{ fontSize: '10px', color: '#5D6062' }}>
                  Doanh số 6 tháng
                </Col>
                <Col style={{ fontSize: '10px' }}>
                  <strong>{item.doanh_so_6_thang_mon ?? '-'}</strong>
                </Col>
              </Col>
            </Row>
            <Row align={'top'} style={{ alignItems: 'flex-start' }}>
              <BoxCube />
              <Col style={{ paddingTop: '8px' }}>
                <Col style={{ fontSize: '10px', color: '#5D6062' }}>
                  Tồn hiện tại
                </Col>
                <Col style={{ fontSize: '10px' }}>
                  <strong>{product.ton_kho_hien_tai_mon ?? '-'}</strong>
                </Col>
              </Col>
            </Row>
            <Col>
              <Divider
                style={{
                  borderTop: '1px dashed rgba(0, 0, 0, 0.2)',
                  marginTop: '8px',
                  marginBottom: '8px',
                }}
                dashed
              />
            </Col>

            <Col>
              <Row
                align={'middle'}
                onClick={() => {
                  if (product.old_order_min && product.old_order_max) {
                    const updatedProduct = { ...product };
                    updatedProduct.order_min = product.old_order_min;
                    updatedProduct.order_max = product.old_order_max;
                    handleMinMaxProduct(index, updatedProduct);
                    setProduct(updatedProduct);
                  }
                }}
              >
                <Col
                  style={{
                    fontSize: '10px',
                    color: '#5D6062',
                    marginRight: '4px',
                  }}
                >
                  Đăng ký
                </Col>
                <Copy />
                <Col
                  style={{
                    fontSize: '10px',
                    color: '#5D6062',
                    marginLeft: '4px',
                    cursor: 'pointer',
                  }}
                >
                  <span className="hover:text-[#33AAFF]">Sao chép đký cũ</span>
                </Col>
              </Row>
            </Col>
            <Col>
              <Row gutter={5} justify="space-between" align="middle">
                <Col style={{ flex: 1 }}>
                  <Row align={'middle'} justify="center">
                    <div style={{ fontSize: '8px' }}>{'Min: '}</div>
                    <strong style={{ fontSize: '10px' }}>
                      {product.old_order_min}
                    </strong>
                  </Row>
                  <Input
                    min={0}
                    style={{
                      height: '28px',
                      width: '100%',
                      borderRadius: '5px',
                      textAlign: 'center',
                    }}
                    type="number"
                    onChange={(event) => ChangeValueMin(event)}
                    defaultValue={product.order_min}
                    value={product.order_min}
                  ></Input>
                </Col>
                <Space></Space>

                <Col style={{ flex: 1 }}>
                  <Row align={'middle'} justify="center">
                    <div style={{ fontSize: '8px' }}>{'Max: '}</div>
                    <strong style={{ fontSize: '10px' }}>
                      {product.old_order_max}
                    </strong>
                  </Row>
                  <Input
                    min={0}
                    style={{
                      height: '28px',
                      width: '100%',
                      borderRadius: '5px',
                      textAlign: 'center',
                    }}
                    type="number"
                    onChange={(event) => ChangeValueMax(event)}
                    defaultValue={product.order_max}
                    value={product.order_max}
                  ></Input>
                </Col>
              </Row>
            </Col>

            <Col style={{ marginTop: '5px' }}>
              <Row>
                <p style={{ fontSize: '10px', color: '#DC362E' }}>
                  {isOrderMinEmpty === true && isOrderMaxEmpty === false
                    ? 'Số lượng min không được bỏ trống'
                    : ''}
                </p>
              </Row>
              <Row>
                <p style={{ fontSize: '10px', color: '#DC362E' }}>
                  {isOrderMinEmpty === false && isOrderMaxEmpty === true
                    ? 'Số lượng max không được bỏ trống'
                    : ''}
                </p>
              </Row>
              <Row>
                <p style={{ fontSize: '10px', color: '#DC362E' }}>
                  {isOrderMinEmpty === true &&
                  isOrderMaxEmpty === true &&
                  checked === true
                    ? 'Số lượng min,max không được bỏ trống'
                    : ''}
                </p>
              </Row>

              <Row>
                <p style={{ fontSize: '10px', color: '#DC362E' }}>
                  {product.order_min <= 0
                    ? 'Số lượng min không được nhỏ hơn hoặc bằng 0'
                    : ''}
                </p>
              </Row>
              <Row>
                <p style={{ fontSize: '10px', color: '#DC362E' }}>
                  {product.order_min > product.order_max
                    ? 'Số lượng min không được lớn hơn số lượng max'
                    : ''}
                </p>
              </Row>
              <Row>
                <p style={{ fontSize: '10px', color: '#DC362E' }}>
                  {product.order_min >= 5
                    ? 'Số lượng đăng kí MIN quá lớn (trên 4 món)'
                    : ''}
                </p>
              </Row>
              <Row>
                <p style={{ fontSize: '10px', color: '#DC362E' }}>
                  {product.order_max >= 5
                    ? 'Số lượng đăng kí MAX quá lớn (trên 4 món)'
                    : ''}
                </p>
              </Row>
              <Row>
                <p style={{ fontSize: '10px', color: '#DC362E' }}>
                  {product.order_max - product.order_min >= 4
                    ? 'Số lượng chênh lệch giữa MIN-MAX quá lớn (trên 3 món)'
                    : ''}
                </p>
              </Row>
              <Row>
                <p style={{ fontSize: '10px', color: '#DC362E' }}>
                  {product.order_min == undefined ||
                  product.order_max == undefined ||
                  product.order_min == null ||
                  product.order_max == null
                    ? ''
                    : validateUnisex(product) === true
                    ? ''
                    : 'Mẫu thuộc nhẫn Unisex, phải đăng ký số lượng MIN-MAX chẵn'}
                </p>
              </Row>
              <Row>
                {' '}
                <p style={{ fontSize: '10px', color: '#DC362E' }}>
                  {product.zma_bo !== '' && IsPackEnough == false
                    ? renderProductInPack(product.zma_bo)
                    : ''}
                </p>
              </Row>
              <Row>
                <p style={{ fontSize: '10px', color: '#DC362E' }}>
                  {IsValidateAgingMin() == false
                    ? 'aging nhỏ hơn hoặc bằng 3, min đăng ký mới không được nhỏ hơn min đăng ký cũ'
                    : ''}
                </p>
              </Row>
              <Row>
                <p style={{ fontSize: '10px', color: '#DC362E' }}>
                  {IsValidateAgingMax() == false
                    ? 'aging nhỏ hơn hoặc bằng 3, max đăng ký mới không được nhỏ hơn max đăng ký cũ'
                    : ''}
                </p>
              </Row>
              <Row>
                <p style={{ fontSize: '10px', color: '#DC362E' }}>
                  {IsAgingRequire() == false
                    ? ''
                    : checked == true
                    ? ''
                    : 'Sản phẩm có Aging = 1,2,3 bắt buộc phải được đăng ký'}
                </p>
              </Row>
            </Col>

            <Col>
              <Divider
                style={{
                  borderTop: '1px dashed rgba(0, 0, 0, 0.2)',
                  marginTop: '8px',
                  marginBottom: '8px',
                }}
                dashed
              />
            </Col>
            <Col>
              <Row
                justify="space-between"
                align="middle"
                style={{ marginTop: '5px' }}
              >
                <Col className="text-secondary" style={{ fontSize: '10px' }}>
                  <strong
                    style={{ cursor: 'pointer' }}
                    onClick={() =>
                      showModal({ product, ChangeValueMin, ChangeValueMax })
                    }
                  >
                    {product.order_min
                      ? formatCurrencyVND(item.cost_price * product.order_min)
                      : '0đ'}
                    {' - '}
                    {product.order_max
                      ? formatCurrencyVND(item.cost_price * product.order_max)
                      : '0đ'}
                  </strong>
                </Col>
                <NavigationRight
                  style={{ cursor: 'pointer' }}
                  onClick={() =>
                    showModal({ product, ChangeValueMin, ChangeValueMax })
                  }
                />
              </Row>
            </Col>
          </Col>
        </Spin>
      )}
    </>
  );
}
